// import Input from "./ui/pro/input/elementor-input";
import Image from "./ui/basic/image/elementor-image";
// import FormRuntime from "./ui/pro/form/elementor-form";
// import Button from "./ui/basic/button/elementor-button";
// import ElementorCard from "./ui/basic/card/elementor-card";
// import ElementorTabs from "./ui/basic/tabs/elementor-tabs";
// import ElementorIcon from "./ui/basic/icons/elementor-icon";
import ImageComponent from "./ui/basic/image/elementor-image";
// import ElementorSheet from "./ui/basic/sheet/elementor-sheet";
// import ElementorDialog from "./ui/basic/dialog/elementor-dialog";
import Typography from "./ui/basic/typography/elementor-typography";
// import ElementorDevider from "./ui/basic/devider/elementor-devider";
// import ElementorAccordions from "./ui/basic/accordions/elementor-accordions";
import Container from "./ui/layout/container/elementor-container";
// import ElementorSwiper from "@/components/core/element/ui/basic/swiper/elementor-swiper";
import { Editor, Frame } from "@craftjs/core";

export default function SlugPageFrame({ serializedBuilderData }) {
    return (
        <Editor
            enabled={false}
            resolver={{
                Container,
                Typography,
                // Button,
                Image,
                ImageComponent,
                // FormRuntime,
                // Input,
                // ElementorCard,
                // ElementorAccordions,
                // ElementorTabs,
                // ElementorDialog,
                // ElementorSheet,
                // ElementorDevider,
                // ElementorIcon,
                // ElementorSwiper,
            }}
        >
            <Frame data={serializedBuilderData} />
        </Editor>
    );
}
